<template>
  <div style="position: relative">
    <NewTextInput
      v-if="isZipcodeProvider"
      :label="t('PAYJOY_CARD_VIEWS.ADDRESS_FORM_POSTAL_CODE')"
      :placeholder="t('PAYJOY_CARD_VIEWS.ADDRESS_FORM_POSTAL_CODE_PLACEHOLDER')"
      :error="!!zipcodeError"
      :errorMessage="zipcodeError ? t(zipcodeError) : ''"
      :disabled="false"
      :errorIcon="false"
      :type="'number'"
      :maxlength="5"
      id="zipcode_autocomplete"
      v-model:value="localInput"
      @input="onAddressInput"
    />
    <NewTextInput
      v-else
      :label="t('PAYJOY_CARD_VIEWS.SHIPPING_FORM_AUTOCOMPLETE_LABEL')"
      :placeholder="
        t('PAYJOY_CARD_VIEWS.SHIPPING_FORM_AUTOCOMPLETE_PLACEHOLDER')
      "
      :error="false"
      :disabled="false"
      id="new_autocomplete"
      v-model:value="localInput"
      @input="onAddressInput"
    />
    <!-- Dropdown only if we have options and not zipcode provider -->
    <AutocompleteOptions
      v-if="!isZipcodeProvider"
      :selectOptions="selectOptions"
      @optionSelected="handleAutocompleteSelect($event)"
    />
  </div>
  <p class="manually-text" @click="$emit('goToManualForm')">
    {{ t("PAYJOY_CARD_VIEWS.SHIPPING_FORM_ENTER_MANUALLY") }}
  </p>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import NewTextInput from "@/apps/credit-line/components/NewTextInput.vue";
import AutocompleteOptions from "@/apps/credit-line/components/AutocompleteOptions.vue";

const { t } = useI18n();

const props = defineProps<{
  autocompleteInput: string;
  selectOptions: Array<{ label: string; value: string; covered?: boolean }>;
  isZipcodeProvider?: boolean;
  zipcodeError?: string | null;
}>();
const emit = defineEmits([
  "goToManualForm",
  "handleAutocompleteSelect",
  "onAddressInput",
]);

const localInput = ref(props.autocompleteInput);

watch(
  () => props.autocompleteInput,
  (newVal) => {
    if (newVal !== localInput.value) {
      localInput.value = newVal;
    }
  }
);
function onAddressInput(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  localInput.value = value;
  emit("onAddressInput", value);
}

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
function handleAutocompleteSelect(option: any) {
  emit("handleAutocompleteSelect", option);
}
</script>

<style scoped>
.manually-text {
  position: relative;
  margin-top: 120px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  font-family: Inter;
  color: #007c3b;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 73px;
  cursor: pointer;
}
</style>
